<h2 mat-dialog-title>Definiciones de la encuesta</h2>
<mat-dialog-content class="mat-typography">

<p>La encuesta Great Place to Work® requiere respuestas de doble perspectiva por su parte. Para cada declaración, debe proporcionar dos respuestas: por área y por Organización.
Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones:</p>

<p>Área se refiere a su experiencia dentro de su departamento</p>
<p>Organización se refiere a su experiencia general trabajando en su empresa</p>
<p>Administración bajo Área se refiere a su supervisor / gerente directo</p>

<p>Administración bajo Organización se refiere a la alta gerencia de su empresa</p>


</mat-dialog-content>
